import { memo, useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { InstanciaTarefa, calcularTempoRestante, tarefaTemTimer } from "./kanbanTypes";

type Props = { tarefa: InstanciaTarefa };

function TempoBadgeImpl({ tarefa }: Props) {
    const ativo = tarefaTemTimer(tarefa);
    const [now, setNow] = useState(() => Date.now());

    useEffect(() => {
        if (!ativo) return;
        const interval = setInterval(() => setNow(Date.now()), 1000);
        return () => clearInterval(interval);
    }, [ativo]);

    if (ativo) {
        const info = calcularTempoRestante(tarefa, now);
        if (info) {
            return (
                <Box sx={{
                    display: "flex", alignItems: "center", gap: 0.3, ml: 1,
                    bgcolor: info.expirado ? "#ffebee" : "#e3f2fd",
                    border: "1px solid",
                    borderColor: info.expirado ? "#ef5350" : "#1565c0",
                    borderRadius: 1, px: 0.6, py: 0.1,
                }}>
                    <AccessTimeIcon sx={{ fontSize: 12, color: info.expirado ? "#ef5350" : "#1565c0" }} />
                    <Typography fontSize={10} fontWeight={700} fontFamily="monospace"
                        color={info.expirado ? "#ef5350" : "#1565c0"}>
                        {info.texto}
                    </Typography>
                </Box>
            );
        }
    }

    if (Number(tarefa.tempo_execucao_horas) > 0) {
        return (
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.3, ml: 1 }}>
                <AccessTimeIcon sx={{ fontSize: 13, color: "text.secondary" }} />
                <Typography fontSize={11} color="text.secondary">
                    {tarefa.tempo_execucao_horas}h
                </Typography>
            </Box>
        );
    }

    return null;
}

export const TempoBadge = memo(TempoBadgeImpl, (a, b) => {
    const ta = a.tarefa;
    const tb = b.tarefa;
    return (
        ta.id_kanban_instancia_tarefa === tb.id_kanban_instancia_tarefa &&
        ta.status === tb.status &&
        ta.inicio_execucao === tb.inicio_execucao &&
        ta.tempo_execucao_horas === tb.tempo_execucao_horas
    );
});
